import {
	GemIcon2,
	Level1Icon,
	Level2Icon,
	Level3Icon,
	MemberPackLeftActiveIcon,
} from "@/components/icons";
import { useLanguage } from "@/hooks/useLanguage";
import { cn, formatThousands } from "@/lib/utils";
import { m } from "@/paraglide/messages";
import { JSX, useMemo } from "react";
import { MemberLevel } from "~/routes/$lang/profile/-api";
import { BillingCycle, OrderProduct, SubscriptionInfoResponse } from "./api";
// 会员等级顺序和映射
// const memberOrder = [
// 	MemberLevel.STANDARD,
// 	MemberLevel.PREMIUM,
// 	MemberLevel.SUPREME,
// ];
const memberNameMap: Record<string, string> = {
	[MemberLevel.STANDARD]: m.profile_account_level_standard(),
	[MemberLevel.PREMIUM]: m.profile_account_level_premium(),
	[MemberLevel.SUPREME]: m.profile_account_level_supreme(),
};
const memberIconMap: Record<string, JSX.Element> = {
	[MemberLevel.STANDARD]: <Level1Icon className="w-[84px] h-auto" />,
	[MemberLevel.PREMIUM]: <Level2Icon className="w-[84px] h-auto" />,
	[MemberLevel.SUPREME]: <Level3Icon className="w-[84px] h-auto" />,
};
const bgMap: Record<string, { light: string; dark: string }> = {
	[MemberLevel.STANDARD]: {
		light: "/assets/images/deposit/card-bg-2.svg",
		dark: "/assets/images/deposit/card-bg-2_dark.svg",
	},
	[MemberLevel.PREMIUM]: {
		light: "/assets/images/deposit/card-bg-3.svg",
		dark: "/assets/images/deposit/card-bg-3_dark.svg",
	},
	[MemberLevel.SUPREME]: {
		light: "/assets/images/deposit/card-bg-4.svg",
		dark: "/assets/images/deposit/card-bg-4_dark.svg",
	},
};
const billingCycleMap: Record<string, string> = {
	[BillingCycle.Daily]: m.profile_deposit_channel_daily(),
	[BillingCycle.WeekLy]: m.profile_deposit_channel_weekly(),
	[BillingCycle.Monthly]: m.profile_deposit_channel_monthly(),
	[BillingCycle.Quarterly]: m.profile_deposit_channel_quarterly(),
	[BillingCycle.SemiAnnual]: m.profile_deposit_channel_semi_annual(),
	[BillingCycle.Yearly]: m.profile_deposit_channel_yearly(),
};

// 会员包卡片组件
export default function MemberPackCard({
	item,
	selected,
	theme,
	onClick,
	subscriptionInfo,
}: {
	item: OrderProduct;
	selected: boolean;
	theme: "light" | "dark";
	onClick: () => void;
	subscriptionInfo: SubscriptionInfoResponse["subscription_info"] | undefined;
}) {
	const lang = useLanguage();
	// 当前卡片是否为激活状态
	const isActive = useMemo(
		() => subscriptionInfo?.product_info?.name === item.name,
		[item.name, subscriptionInfo?.product_info?.name],
	);

	const bg = bgMap[item.name]?.[theme] || "";

	console.log(item.price, "item.price");
	console.log(formatThousands(item.price), "formatThousands");

	return (
		<div
			key={`${item.price}-${item.name}`}
			className={cn(
				"group relative overflow-hidden h-[180px] cursor-pointer text-center flex-1 shadow-card bg-[#FFFEFF] dark:bg-bg2 rounded-[14px] px-6 py-3 flex flex-col items-center",
			)}
			onClick={!isActive ? onClick : undefined}
		>
			{isActive && (
				<MemberPackLeftActiveIcon className="absolute top-[-1px] left-[-1px] z-2" />
			)}
			{item.discount_info && (
				<span className="absolute top-0 right-0 z-2 bg-c5/55 rounded-bl-[14px] rounded-tr-[14px] text-xs font-medium text-w1 px-2 h-[25px] flex items-center justify-center">
					{item.discount_info}
				</span>
			)}
			<div
				className={cn(
					"w-full h-full absolute rounded-[14px] transition-all duration-300 bottom-0 left-0 z-1 border-2 border-main1 opacity-0 group-hover:opacity-100",
					isActive && "!opacity-0",
					selected && "opacity-100",
					isActive && "!opacity-100 border-[#D2D2D2] border-1",
				)}
			/>
			<div className="absolute -top-0 left-1/2 -translate-x-1/2 z-2 flex flex-col items-center w-full">
				{memberIconMap[item.name]}
				<p className="text-sm text-t2 font-medium mt-2">
					{memberNameMap[item.name] || item.name}
				</p>
			</div>
			<div className="relative z-2 h-6 mb-3 mt-20 flex gap-1 items-center text-[#B37689] text-[20px] md:text-[24px] font-black">
				{formatThousands(item.product_amount)}
				<span className="text-sm text-t2 gap-1 font-medium flex items-center min-w-[62px]">
					<GemIcon2 className="w-8 h-8" />/
					{billingCycleMap[item.billing_cycle] || item.billing_cycle}
				</span>
			</div>
			<div
				className={cn(
					"relative z-2 w-full h-10 text-[#91467F] dark:text-t2 text-lg leading-5 font-bold flex px-4 items-center justify-center rounded-full bg-linear-to-b from-[#FAEAF6] to-[#FFF2FC] dark:bg-none dark:bg-[#4A4A4A]",
					isActive && "grayscale-100",
				)}
			>
				<div
					className={cn(
						"flex items-end text-sm md:text-base font-bold gap-1",
						isActive && "opacity-80",
					)}
				>
					<span className="text-xs font-medium relative -top-[3.5px]">
						{item.currency_symbol}
					</span>
					{formatThousands(item.price)}
					<span
						className={cn(
							"text-sm font-medium mr-1.5 relative -top-[3px]",
							isActive && "opacity-80",
						)}
					>
						/{billingCycleMap[item.billing_cycle] || item.billing_cycle}
					</span>
				</div>
			</div>
			<img
				src={bg}
				alt="card-bg"
				className="w-[80%] h-auto absolute bottom-0 right-0 z-0"
			/>
		</div>
	);
}
